// src/Action/BankAction/BankTransactionAction.js
import { toast } from 'sonner';
import axiosInstance from '../axiosInstance';
import { financePath } from '../../../utils/financePath';

// ── Action Types ──────────────────────────────────────────────────────────────
export const FETCH_BANK_TXN_ACCOUNTS_REQUEST = 'FETCH_BANK_TXN_ACCOUNTS_REQUEST';
export const FETCH_BANK_TXN_ACCOUNTS_SUCCESS = 'FETCH_BANK_TXN_ACCOUNTS_SUCCESS';
export const FETCH_BANK_TXN_ACCOUNTS_FAILURE = 'FETCH_BANK_TXN_ACCOUNTS_FAILURE';

export const FETCH_BANK_TRANSACTIONS_REQUEST = 'FETCH_BANK_TRANSACTIONS_REQUEST';
export const FETCH_BANK_TRANSACTIONS_SUCCESS = 'FETCH_BANK_TRANSACTIONS_SUCCESS';
export const FETCH_BANK_TRANSACTIONS_FAILURE = 'FETCH_BANK_TRANSACTIONS_FAILURE';

export const FETCH_BANK_TXN_CHART_REQUEST = 'FETCH_BANK_TXN_CHART_REQUEST';
export const FETCH_BANK_TXN_CHART_SUCCESS = 'FETCH_BANK_TXN_CHART_SUCCESS';
export const FETCH_BANK_TXN_CHART_FAILURE = 'FETCH_BANK_TXN_CHART_FAILURE';

export const FETCH_BANK_TXN_EXPORT_REQUEST = 'FETCH_BANK_TXN_EXPORT_REQUEST';
export const FETCH_BANK_TXN_EXPORT_SUCCESS = 'FETCH_BANK_TXN_EXPORT_SUCCESS';
export const FETCH_BANK_TXN_EXPORT_FAILURE = 'FETCH_BANK_TXN_EXPORT_FAILURE';

// ── Fetch Bank Accounts (for dropdown) ───────────────────────────────────────
export const Fetch_BankTxnAccounts =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BANK_TXN_ACCOUNTS_REQUEST });
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `bank/transactions/accounts?${queryString}` : 'bank/transactions/accounts';
      const response = await axiosInstance.get(financePath(url));
      dispatch({ type: FETCH_BANK_TXN_ACCOUNTS_SUCCESS, payload: response.data.data });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.error || 'Failed to fetch bank accounts';
      dispatch({ type: FETCH_BANK_TXN_ACCOUNTS_FAILURE, payload: msg });
      toast.error(msg);
      throw error;
    }
  };

// ── Fetch Transactions (main) ─────────────────────────────────────────────────
export const Fetch_BankTransactions =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BANK_TRANSACTIONS_REQUEST });
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(financePath(`bank/transactions?${queryString}`));
      dispatch({ type: FETCH_BANK_TRANSACTIONS_SUCCESS, payload: response.data.data });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.error || 'Failed to fetch transactions';
      dispatch({ type: FETCH_BANK_TRANSACTIONS_FAILURE, payload: msg });
      toast.error(msg);
      throw error;
    }
  };

// ── Fetch Chart Data ──────────────────────────────────────────────────────────
export const Fetch_BankTxnChart =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BANK_TXN_CHART_REQUEST });
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(financePath(`bank/transactions/chart?${queryString}`));
      dispatch({ type: FETCH_BANK_TXN_CHART_SUCCESS, payload: response.data.data });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.error || 'Failed to fetch chart data';
      dispatch({ type: FETCH_BANK_TXN_CHART_FAILURE, payload: msg });
      throw error;
    }
  };

// ── Export Transactions ───────────────────────────────────────────────────────
export const Export_BankTransactions =
  (params = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BANK_TXN_EXPORT_REQUEST });
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(financePath(`bank/transactions/export?${queryString}`));
      dispatch({ type: FETCH_BANK_TXN_EXPORT_SUCCESS, payload: response.data.data });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.error || 'Failed to export transactions';
      dispatch({ type: FETCH_BANK_TXN_EXPORT_FAILURE, payload: msg });
      toast.error(msg);
      throw error;
    }
  };